import { ReactComponent as AiIcon } from 'assets/static/ai-icon.svg';
import { ReactComponent as MenuIcon } from 'assets/static/menu-icon.svg';
import { ReactComponent as TranslateIcon } from 'assets/static/translate-icon.svg';
import { ReactComponent as Zamochki } from 'assets/static/zamochki.svg';
import { useAppDispatch, useAppSelector } from 'hooks/store';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useGetSubscription } from 'store/subscription/actions';
import { hideSubscriptionModal } from 'store/subscriptionNotification/actions';

import { AppModal } from './AppModal';
import { Spinner } from './Spinner';

export const SubscriptionModalStatus = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { isOpen } = useAppSelector((state) => state.subscriptionNotification);
  const { data: subscription, isError, isPending } = useGetSubscription();

  if (isError) {
    return null;
  }

  if (isPending) {
    return <Spinner />;
  }

  const activeSubscription = subscription?.subscriptions.find(
    (sub) => sub.product_type.toLowerCase() === 'menu',
  );

  const isCancel = activeSubscription?.status === 'Cancel';

  const closeModal = () => {
    dispatch(hideSubscriptionModal());
  };

  const goToSubscription = () => {
    history.push('/subscription');
    dispatch(hideSubscriptionModal());
  };

  return (
    <AppModal
      size="sm:max-w-5xl !p-0 overflow-x-hidden"
      open={isOpen}
      onClose={closeModal}
    >
      <div className="flex items-stretch">
        <div className="flex flex-col flex-1 px-4 pt-5 pb-4 sm:p-6">
          <div className="text-2xl font-bold mb-6">
            <FormattedMessage
              id={isCancel ? 'subscriptionCancelTitle' : 'subscriptionExploreTitle'}
            />
          </div>

          <div className="text-sm mb-10">
            <FormattedMessage
              id={isCancel ? 'subscriptionCancelSubtitle' : 'subscriptionExploreSubtitle'}
              values={{
                b: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
              }}
            />
          </div>

          <div className="flex items-start gap-3 mb-3">
            <MenuIcon className="h-auto" />

            <div className="flex flex-col">
              <div className="text-sm font-bold">
                <FormattedMessage
                  id={
                    isCancel
                      ? 'subscriptionCancelBuildMenuTitle'
                      : 'subscriptionExploreBuildMenuTitle'
                  }
                />
              </div>
              <div className="text-sm">
                <FormattedMessage
                  id={
                    isCancel
                      ? 'subscriptionCancelBuildMenuDescription'
                      : 'subscriptionExploreBuildMenuDescription'
                  }
                />
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3 mb-3">
            <AiIcon className="h-auto" />

            <div className="flex flex-col">
              <div className="text-sm font-bold">
                <FormattedMessage
                  id={
                    isCancel ? 'subscriptionCancelAiTitle' : 'subscriptionExploreAiTitle'
                  }
                />
              </div>
              <div className="text-sm">
                <FormattedMessage
                  id={
                    isCancel
                      ? 'subscriptionCancelAiDescription'
                      : 'subscriptionExploreAiDescription'
                  }
                />
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3 mb-10">
            <TranslateIcon className="h-auto" />

            <div className="flex flex-col">
              <div className="text-sm font-bold">
                <FormattedMessage
                  id={
                    isCancel
                      ? 'subscriptionCancelTranslateTitle'
                      : 'subscriptionExploreTranslateTitle'
                  }
                />
              </div>
              <div className="text-sm">
                <FormattedMessage
                  id={
                    isCancel
                      ? 'subscriptionCancelTranslateDescription'
                      : 'subscriptionExploreTranslateDescription'
                  }
                />
              </div>
            </div>
          </div>

          <div className="text-sm mb-6">
            <FormattedMessage
              id={
                isCancel
                  ? 'subscriptionCancelSubDescription'
                  : 'subscriptionExploreSubDescription'
              }
              values={{
                b: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
              }}
            />
          </div>

          <button
            onClick={goToSubscription}
            className="whitespace-nowrap break-normal flex w-full justify-center rounded-md border border-transparent bg-primary py-2 px-4 text-sm font-medium text-white shadow-sm md:hover:bg-indigo-700 md:focus:outline-none md:focus:ring-2 md:focus:ring-indigo-500 md:focus:ring-offset-2 mb-1"
          >
            <FormattedMessage
              id={isCancel ? 'subscriptionCancelButton' : 'startFreeTrial'}
            />
          </button>
          <div className="text-xs text-[#54422e] w-full text-center">
            <FormattedMessage
              id={
                isCancel
                  ? 'subscriptionCancelSubButtonText'
                  : 'subscriptionExploreSubButtonText'
              }
            />
          </div>
        </div>
        <div className="max-w-[400px] lg:max-w-[600px] hidden md:flex items-center justify-center bg-[#f9f9f8]">
          <Zamochki className="max-w-[400px] lg:max-w-[600px] h-auto" />
        </div>
      </div>
    </AppModal>
  );
};
